// Configuration for different environments
// Automatically detects environment based on NODE_ENV or hostname
const getEnvironment = (): 'development' | 'production' => {
  // Check if we're in production build
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  // Check if we're running on a production domain (not localhost)
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return 'production';
  }
  return 'development';
};

const config = {
  development: {
    backendUrl: 'http://localhost:8080'
  },
  production: {
    // Use relative URL in production (same domain) or set your production API URL
    backendUrl: process.env.REACT_APP_API_URL || window.location.origin.replace(/:\d+$/, ':8080')
  }
};

const environment = getEnvironment();
export const backendUrl = config[environment].backendUrl; 
